var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ButtonBorderedKVBase, ButtonKVBase, DefaultModal, IconButton } from '@/presentation/components';
import React, { useEffect } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { IconArrowBack, IconSend2, IconSimCard2, IconDanger, IconCircleClose2 } from '@/presentation/components/icons';
import cssnames from 'classnames';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { uploadFromCsvTeacherState } from './atoms';
import Step0 from './steps/step-0';
import Step1 from './steps/step-1';
import Step2 from './steps/step-2';
import Skeleton from 'react-loading-skeleton';
import Styles from '../styles/modal-upload-styles.scss';
const ModalUploadTeachers = ({ validation, saveCsvFile, idClient, onSuccess }) => {
    const [state, setState] = useRecoilState(uploadFromCsvTeacherState);
    const { step, openMainModal, step0Ready, step1Ready, step2Ready, modalClose, fileParsedResult, isLoading } = state;
    const resetState = useResetRecoilState(uploadFromCsvTeacherState);
    const { toastContainer, showCustomError } = useCustomToast({
        containerId: 'ModalUploadTeachers',
        toastClassName: Styles.toastClassName
    });
    const toggleModalClose = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { modalClose: flag })));
    const validateColumns = () => {
        if (state.firstNameTableValidation === '' ||
            state.lastNameTableValidation === '' ||
            state.emailTableValidation === '' ||
            state.classGradeTableValidation === '') {
            return false;
        }
        return true;
    };
    const setStep = (stepParam) => {
        var _a;
        if (stepParam === 1) {
            if (fileParsedResult && ((_a = fileParsedResult === null || fileParsedResult === void 0 ? void 0 : fileParsedResult.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setState(prev => (Object.assign(Object.assign({}, prev), { step: stepParam })));
                return;
            }
            else {
                showCustomError('File is required to select', 'Please select a CSV file to continue');
                return;
            }
        }
        if (stepParam === 2) {
            if (validateColumns()) {
                setState(prev => (Object.assign(Object.assign({}, prev), { step: stepParam, step1Ready: true })));
                return;
            }
            else {
                showCustomError('Please map all fields  to continue', 'Eaсh field should be either matched or skipped');
                return;
            }
        }
        setState(prev => (Object.assign(Object.assign({}, prev), { step: stepParam })));
    };
    const confirmCloseModal = () => __awaiter(void 0, void 0, void 0, function* () {
        const processCompleted = state.processCompleted;
        const recordsInserted = state.recordsInserted;
        const recordsFailed = state.recordsFailed;
        yield resetState();
        setState(prev => (Object.assign(Object.assign({}, prev), { processCompleted, recordsInserted, recordsFailed })));
    });
    const addTeachers = () => {
        setState(prev => (Object.assign(Object.assign({}, prev), { modalMessageSave: true })));
    };
    useEffect(() => {
        if (state.processCompleted && onSuccess)
            onSuccess();
    }, [state.processCompleted]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DefaultModal, { height: "95", hUnit: "%", width: "90", wUnit: "%", open: openMainModal, onClose: () => toggleModalClose(true), overlayCustomStyles: { zIndex: 9999 }, contentCustomStyles: {
                padding: 25,
                transform: 'translate(-50%, -46%)',
                borderRadius: '16px 16px 0px 0px'
            } },
            React.createElement("div", { className: Styles.mainModalWrap, "data-testid": "global-modal-upload-csv" },
                React.createElement("div", { className: Styles.headerWrap },
                    React.createElement("div", { className: Styles.titleWrap },
                        React.createElement("div", { className: Styles.subTitleWrap },
                            React.createElement("div", { className: Styles.title }, "Add teachers from CSV"),
                            React.createElement("div", { className: Styles.closeIconBtn },
                                React.createElement(IconButton, { onClick: () => toggleModalClose(true) },
                                    React.createElement(IconCircleClose2, null)))),
                        React.createElement("div", { className: Styles.subtitle },
                            step === 0 && (React.createElement(React.Fragment, null,
                                "CSV file should contain next information: ",
                                React.createElement("span", null, "First Name, Last Name, Email and Class Grade."),
                                ' ',
                                "However you will be able to manually add missed information on the next steps.")),
                            step === 1 && (React.createElement(React.Fragment, null, "Please match the data from your file with required information. You can also skip missed fields and manually add that information on the next step.")))),
                    React.createElement("div", null,
                        React.createElement("div", { className: Styles.cancelBtn },
                            React.createElement(ButtonBorderedKVBase, { type: "button", color: "black", onClick: () => toggleModalClose(true) }, "Cancel")))),
                React.createElement("div", { className: Styles.tabWrap },
                    React.createElement("div", { className: cssnames(Styles.tab, { [Styles.tabSelected]: step === 0 }, { [Styles.tabReady]: step0Ready }), onClick: () => setStep(0) },
                        React.createElement("p", null, "1. Select File")),
                    React.createElement("div", { className: cssnames(Styles.tab, { [Styles.tabSelected]: step === 1 }, { [Styles.tabReady]: step1Ready }), onClick: () => setStep(1) },
                        React.createElement("p", null, "2. Map Fields")),
                    React.createElement("div", { className: cssnames(Styles.tab, { [Styles.tabSelected]: step === 2 }, { [Styles.tabReady]: step2Ready }), onClick: () => setStep(2) },
                        React.createElement("p", null, "3. Preview Results"))),
                React.createElement("div", { className: Styles.loadingWrap }, isLoading && React.createElement(Skeleton, { count: 1, height: 20, borderRadius: "0.5rem", duration: 1 })),
                React.createElement("div", { className: step === 2 ? Styles.bodyStep2 : Styles.body },
                    step === 0 && React.createElement(Step0, null),
                    step === 1 && React.createElement(Step1, null),
                    step === 2 && React.createElement(Step2, { validation: validation, saveCsvFile: saveCsvFile, idClient: idClient }))),
            React.createElement("div", { className: Styles.footerWrap },
                React.createElement("div", null,
                    React.createElement(ButtonBorderedKVBase, { type: "button", color: step === 0 ? '#999999' : '#00A3FF', onClick: () => setStep(step - 1), leftIcon: React.createElement(IconArrowBack, { color: step === 0 ? '#999999' : '#00A3FF' }), leftIconClass: Styles.leftIconWrap, btnChildClass: Styles.btnChildBack, disabled: step === 0, "data-testid": "btn-back-step", loading: state.isLoading }, "Back")),
                step === 2 && (React.createElement("div", { className: Styles.bMessageWrap },
                    React.createElement("div", { className: Styles.bInnerMessageWrap },
                        React.createElement("div", null,
                            React.createElement(IconSend2, null)),
                        React.createElement("div", { className: Styles.message },
                            "Total teachers to invite: ",
                            React.createElement("b", null, state.teacherToInvite))),
                    React.createElement("div", { className: Styles.bInnerMessageWrap },
                        React.createElement("div", null,
                            React.createElement(IconSimCard2, null)),
                        React.createElement("div", { className: Styles.message },
                            "Duplicates found:: ",
                            React.createElement("b", null, state.duplicates))),
                    React.createElement("div", { className: Styles.bInnerMessageWrap },
                        React.createElement("div", null,
                            React.createElement(IconDanger, null)),
                        React.createElement("div", { className: Styles.message },
                            "Issues found: ",
                            React.createElement("b", null, state.issuesFound))))),
                React.createElement("div", null, step === 2 ? (React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: addTeachers, testId: "btn-add-records", loading: state.isLoading }, "Add Teachers")) : (React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: () => setStep(step + 1), testId: "btn-next-step", loading: state.isLoading }, "Next step"))))),
        React.createElement(DefaultModal, { height: "300", hUnit: "px", width: "432", wUnit: "px", open: modalClose, onClose: () => toggleModalClose(false), overlayCustomStyles: { zIndex: 10000 } },
            React.createElement("div", { className: Styles.closeModalWrap },
                React.createElement("div", { className: Styles.title }, "Are you sure to quit?"),
                React.createElement("div", { className: Styles.detail }, "All unsaved progress will be lost"),
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: confirmCloseModal, btnWrapClass: Styles.widthAuto }, "Confirm"),
                React.createElement(ButtonBorderedKVBase, { type: "button", color: '#999999', onClick: () => toggleModalClose(false) }, "Cancel"))),
        toastContainer));
};
export default ModalUploadTeachers;
